import Ini from "./ini";
const fs = window.require("fs");
const os = window.require("os");

export const iniReader = (path) => {
  try {
    return Ini.ini.parseSync(path);
  } catch (e) {
    return undefined;
  }
};

export const iniWriter = (path, obj) => {
  let ini = "";
  if (typeof obj === "object") {
    for (let section in obj) {
      ini += "[" + section + "]" + os.EOL;
      for (let key in obj[section]) {
        ini += key + "=" + obj[section][key] + os.EOL;
      }
    }
  } else if (typeof obj === "string") {
    ini = obj;
  } else {
    return false;
  }
  try {
    ini = ini.trim(); // Common.trimStartEnd(ini, '\\s')
    fs.writeFileSync(path, ini);
    return true;
  } catch (e) {
    console.error(e);
    return false;
  }
};



// WEBPACK FOOTER //
// ./src/topography/js/iniReaderWriter.js